import React, { useEffect, useState } from "react";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { Menu, MenuProps, Skeleton } from "antd";
import { useHistory, useLocation } from "react-router";
import { getSidebarMenu } from "../../menus";
import { hasCapability } from "@Utils";
import SessionManager from "@Core/session";
import { SkeletonRows } from "@Components/shared/SkeletonRows";
import { getBranding } from "@Branding";

interface IProps {
    skeleton: boolean;
}

const SidebarMenu: React.FC<IProps> = ({ skeleton }: IProps) => {
    const [selectedItem, updateItem] = useState(null);
    const history = useHistory();
    const { pathname } = useLocation();
    const sidebarMenu = getSidebarMenu(SessionManager.getServiceUser()?.userId);

    const onClick: MenuProps["onClick"] = (e) => {
        history.push(sidebarMenu.find((x) => x.text === e.key).path);
    };

    const getSkeletonItems = () => {
        const items: ItemType[] = [];
        for (let i = 0; i < 5; i++) {
            items.push({
                label: <SkeletonRows count={1} rowHeight={12} />,
                key: "skeleton-item-" + i,
                icon: <Skeleton.Avatar active={true} size={12} shape={"circle"} />,
            });
        }
        return items;
    };

    const items: ItemType[] = skeleton
        ? getSkeletonItems()
        : sidebarMenu.map((item) => {
              const menuItem = {
                  label: item.text,
                  key: item.text,
                  icon: item.icon,
                  path: item.path,
              };
              if (item.capability !== undefined && item.contextId !== undefined) {
                  if (hasCapability(item.capability, item.contextId)) {
                      return menuItem;
                  }
              } else {
                  return menuItem;
              }
              return null;
          });

    useEffect(() => {
        let selectedKey;
        if (pathname === "/") {
            selectedKey = "profile";
        } else {
            selectedKey = pathname.split("/")[1];
        }
        updateItem(selectedKey);
    }, [pathname]);

    const findSelectedMenuItem = (selectedItem: string, item: string) => {
        const itemMap = {
            "edit-consumables": "consumables",
            "video-library": "video library",
            "ai-assistant": "ai assistant"
        };

        return itemMap[selectedItem] === item || selectedItem === item;
    };

    return (
        <Menu
            style={{ backgroundColor: getBranding("--sidebar-background") }}
            theme="dark"
            mode="inline"
            onClick={onClick}
            selectedKeys={[selectedItem]}
        >
            {items
                .filter((item) => item) // remove null items
                .map((item) => {
                    return (
                        <Menu.Item
                            key={item.key}
                            className={
                                findSelectedMenuItem(selectedItem, item.key.toString().toLowerCase())
                                    ? "selected"
                                    : null
                            }
                        >
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                {"icon" in item ? item.icon : null}
                                {"label" in item ? item.label : null}
                            </div>
                        </Menu.Item>
                    );
                })}
        </Menu>
    );
};

export default SidebarMenu;
